<template>
  <div ref="wg-page-controls" class="wg-page-controls">
    <template v-if="itemsNum">
      <div class="page-label" @click="isPageControlsMenuOpen = true">
        {{ offset + 1 }} - {{ (offset + limit) > itemsNum ? itemsNum : offset + limit }} {{ totalItemsSeparator }}
        {{ itemsNum }}
      </div>
      <div class="change-page-btn" @click="prevPageClickHandler">&lt;</div>
      <div class="change-page-btn" @click="nextPageClickHandler">&gt;</div>
      <div v-if="isPageControlsMenuOpen" class="wg-page-controls-menu">
        <div @click="firstPageClickHandler">{{ $anm22.strLang(language, 'Start', 'Inizio') }}</div>
        <div @click="lastPageClickHandler">{{ $anm22.strLang(language, 'End', 'Fine') }}</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    offset: Number,
    limit: Number,
    itemsNum: Number,
    language: {
      type: String,
      default: "en",
    },
    prevPageClick: {
      type: Function,
      default: () => {},
    },
    nextPageClick: {
      type: Function,
      default: () => {},
    },
    firstPageClick: {
      type: Function,
      default: () => {},
    },
    lastPageClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isPageControlsMenuOpen: false,
    };
  },
  computed: {
    totalItemsSeparator() {
      return this.language == "it" ? "di" : "of";
    },
  },
  methods: {
    checkOutsideClick(event) {
      const me = this.$refs['wg-page-controls'];
      let target = event.target;
      if(!me.contains(target)) {
        this.isPageControlsMenuOpen = false;
      }
    },
    prevPageClickHandler() {
      this.isPageControlsMenuOpen = false;
      this.prevPageClick();
    },
    nextPageClickHandler() {
      this.isPageControlsMenuOpen = false;
      this.nextPageClick();
    },
    firstPageClickHandler() {
      this.isPageControlsMenuOpen = false;
      this.firstPageClick();
    },
    lastPageClickHandler() {
      this.isPageControlsMenuOpen = false;
      this.lastPageClick();
    },
  },
  mounted() {
    document.addEventListener('click', this.checkOutsideClick);
  },
};
</script>

<style lang="scss" scoped>
@import "../../libs/anm22_web_graphics/v1/scss/pageControls";

.wg-page-controls {
  .wg-page-controls-menu {
    display: block;
  }
}
</style>
